export class OrderItemModel {
  constructor() {
    this.products = [];
    this.product_id = null;
    this.unitTypeId = null;
    this.count = null;
    this.isEditing = false;
  }

  create() {
    this.isEditing = true;
    this.isNew = true;
  }
}
